import { Box,Button,Flex,Select,InputGroup,UnorderedList, ListItem,
    InputLeftElement, Heading, Text, Switch,
    TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Image,
    Link,
    FormControl,
    FormErrorMessage,
    InputRightElement,
    Input} from "@chakra-ui/react";
    import { FaRegFile as FileIcon,FaTimes as CancelIcon } from "react-icons/fa";
  import { TopDisplay,UploadButton } from "../../../components";
  import { BsDownload as DownloadIcon } from "react-icons/bs";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import React, { useState ,useEffect, useMemo, useRef} from "react";
  // import styled from "@emotion/styled";
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import { Formik,Form,Field } from "formik";
  import {TablePopUp} from '../../../components';
  import { MdMoreVert as MoreIcon } from "react-icons/md";
  import { Loader } from "../../../customs";
  import { FcInvite as InviteIcon} from "react-icons/fc";
  import apiCall from '../../../utils/apiCall';
  import { TbReload as ReloadIcon } from "react-icons/tb";
  import ReactPaginate from 'react-paginate';
  import { useDropzone } from 'react-dropzone';
  import apiCallFormData from '../../../utils/apiFormDataCall';
  import { BsUpload as UploadIcon} from "react-icons/bs";
  import {
    Grid,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    PopoverAnchor,
  } from '@chakra-ui/react'
  import {useAtom,atom} from 'jotai'
  import { modalAtom, openAtom, notificationAtom, openNAtom } from "../../../context";
  import { format } from "date-fns";
  import * as Yup from 'yup';
  import styled from "@emotion/styled";
  import * as XLSX from 'xlsx';
  import { saveAs } from 'file-saver';
  import { userAtom } from '../../../store'; // Adjust import

  const ExcelTemplateData: BulkReceiptData[] = [
    {
      MembershipNo: "1/0000001",
      Amount: "4000",
      DueYear: "2014",
      Status: "Paid",
    },
  ];
  export interface BulkReceiptData {
    MembershipNo: string;
    Amount: string;
    DueYear: string;
    Status: string;
  }

  type CandidateType={
    ActionId:number;
    Amount:number;
    Branch: string | undefined;
    BranchId: number;
    DueYear: string;
    Email: string | undefined;
    Gender: string | undefined;
    MembershipNo: string ;
    MembershipType: string | undefined;
    Name: string | undefined
    Organization: string | undefined;
    OutstandingAmount: string | undefined;
    RouteId: string | undefined;
    phoneNo: string | undefined;
  }
  
  const src=`/public-assets/upload_icon.png`;
  
  const indexAtom = atom<number | null>(null);
  const list = [
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
  ]
  
  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    padding:'5px 5px',
    thcolor:'var(--dark-green-color)'
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type{
      width:50px;
      height:63px;
      & > div{
        display:none;
      }
    }
    &:hover > *{
      cursor: pointer;
      background-color:var(--table-highlight);
    } 
    & > td{
      width:140px;
    }
    &:hover > td:last-of-type{
      
      & > div{
        display: block;
      }
    }
    & > td > div.active{
      display: block;
    }
  `
  
  export default function UploadPayment() {
    const [hide,set_hide] = useState<boolean>(true);
    const [activeIndex] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);
    const [page,setPage] = useState<number>(1);
    const [page_size,setPageSize] = useState<number>(1);
    const [total_count,setTotalCount] = useState<number>(1);
    const [page_count,setPageCount] = useState<number>(1);
    const [subscriptions,setSubscriptions] = useState<Record<string,any>>([]);
    const [search,set_search] = useState<string>('');
    const [search_term,setSearchTerm] = useState<string>('');
    const queryClient = useQueryClient()
    
    const { data: allData, isLoading } = useQuery({
      queryKey:['all-subscription',page,search],
      queryFn:async () => {
        console.log(page,'page');
        return  apiCall().get(`/MembershipSetUp/member/GetAllPendingSubscriptionInvoiceForStudent?hasPaid=false&PageNumber=${page}&PageSize=100&SearchTerm=${search}`)
      },
        select: (data: any) => data.data, // Return full array of data
        keepPreviousData:false,
        retry:0,
      }
    );
    const { tempSubscriptions,tempTotalData,tempTotalPage,tempPageSize} = useMemo(()=>{
  
      console.log(allData,'allData')
      return ({
        tempSubscriptions:allData?.Data || [],
        tempTotalData: allData?.TotalCount || 1,
        tempTotalPage: allData?.PageCount || 1,
        tempPageSize: allData?.PageSize || 1,
      })
    },[allData])

    // useEffect(()=>{
    //   const handleSearchOnEnter = (e: any)=>{
    //     let key = e.key;
    //     console.log(key,'key')
    //     if(key.toLowerCase() === 'enter'){
    //       if(search && search?.length > 0){
    //         setSearchTerm(search);
    //       }
    //     }
    //   }
    //   window.addEventListener('keydown',handleSearchOnEnter);
    //   return () => window.removeEventListener('keydown',handleSearchOnEnter)
    // },[])
    
    
  
    // const handleSearch = (e: any) => {
    //   const val = e?.target?.value || ""; // safely extract value
    //   set_search(val);
    
    //   const trimmedVal = val.trim().toLowerCase();
    
    //   if (!trimmedVal) {
    //     set_filter_data(subscription); // reset to full list
    //     return;
    //   }
    //   const filtered = (subscription || []).filter((student: any) => {
    //     const studentNo = String(student?.StudentNo || "").toLowerCase();
    //     const fullName = `${student?.FirstName || ""} ${student?.LastName || ""}`.toLowerCase();
    //     return studentNo.includes(trimmedVal) || fullName.includes(trimmedVal);
    //   });
    
    //   set_filter_data(filtered.length > 0 ? filtered : subscription);
    // };
    
    useEffect(() => {
      if (search && subscriptions && subscriptions.length > 0) {
        handleSearch(search);
      } else {
        set_filter_data(subscriptions);
      }
    }, [subscriptions, search]);

    useEffect(()=>{
      setPageCount(()=>tempTotalPage);
      setPageSize(()=>tempPageSize);
      setTotalCount(()=>tempTotalData);
      setSubscriptions(()=>tempSubscriptions)
    },[tempTotalData,tempTotalPage,tempPageSize,tempSubscriptions])
    
    
  
    const handleSearch = (val: string) => {
      set_search(val);
    };
    
    
    
    
    // const handleSearch = (e: any) => {
    //   let val = e.target.value;
    //   set_search(val);

    //   if (val) {
    //     let new_data = filter_data?.filter((eData: any) => {
    //       const studentNoMatches = eData.StudentNo?.toString().toLowerCase().includes(val.toLowerCase());
    //       const otherFieldsMatch = Object.values(eData).join('').toLowerCase().includes(val.toLowerCase());
    //       return studentNoMatches || otherFieldsMatch;
    //     });

    //     set_filter_data(new_data.length > 0 ? new_data : subscription);
    //   } else {
    //     set_filter_data(subscription);
    //   }
    // };
  
  
  
    const [filter_data,set_filter_data] = useState<any>(subscriptions);
  
    
    const itemsPerPage = 100;
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = filter_data?.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
    const handlePageClick = (event:any) => {
      const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
      setPage(()=>event.selected + 1);
    };

         
    const [loadingDownload, setLoadingDownload] = useState(false);

    const downloadTemplate = (data: any[], fileName: string) => {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const fileData = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      saveAs(fileData, `${fileName}.xlsx`);
    };
    
    const showUploadManualSubscription = () =>{
      set_modal({
        header:' Bulk Upload Subscription payment',
        content:<UploadManualSubscription />
      })
      set_open(true);
    }
       

    const showDownloadTemplate = () => {
      try {
        setLoadingDownload(true);
        downloadTemplate(ExcelTemplateData, 'Download Bulk Payment Template');
        set_notification({
          type: 'success',
          message: 'Template downloaded successfully',
        });
        set_Nopen(true);
      } catch (error) {
        set_notification({
          type: 'error',
          message: 'Error occurred while downloading template',
        });
        set_Nopen(true);
      } finally {
        setLoadingDownload(false);
      }
    };
    
  
    // useEffect(()=>{
    //   //console.log(selected_status,'s_status')
    //   if(selected_status){
    //     let data = subscription.filter((eData:any) => eData.Status.toLowerCase().trim().includes(selected_status.toLowerCase().trim()));
    //     if(data.length > 0){
    //       set_filter_data(data);
    //     }
    //   }
    //   else{
    //     set_filter_data(subscription);
    //   }
    // },[selected_status])
  
  
  
    return (
      <>
     {isLoading?<Loader />:
  
      <Box>
        <TopDisplay label="Treat Manual Subscription" button_array={[
            <Button  bg="var(--dark-green-color)" color="var(--white-color)"   leftIcon={<UploadIcon/>}    variant="outline"
              colorScheme="var(--dark-green-color)"
              onClick={showUploadManualSubscription}
            >Bulk Treat Subscription Payment</Button>,
            <Button
            variant="outline"
            bg="var(--white-color)"
            color="var(--dark-green-color)"
            leftIcon={<DownloadIcon />}
            colorScheme="var(--dark-green-color)"
            disabled={loadingDownload}
            onClick={showDownloadTemplate}
          >
            {loadingDownload ? 'Loading' : 'Download Bulk Upload Template'}
          </Button>
          
              ,
           
          ]} />
          <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="300px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.300" />
            </InputLeftElement>
            <Input
              type="text"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
              onBlur={()=>{
                if(search?.length > 0){
                  setSearchTerm(search)
                }
              }}
              placeholder="Search by Student No or Name"
              bg="var(--white-color)"
              borderColor="var(--dark-green-color)"
            
            />
            <span
              style={{
                position: "absolute",
                zIndex: "1",
                right: "10px",
                cursor: "pointer",
                top: "12px",
              }}
              onClick={() => {
                set_search("");
                set_filter_data(subscriptions || []); // fallback in case subscription is undefined
              }}
            >
              <ReloadIcon />
            </span>
          </InputGroup>



          </Flex>
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">All Pending subscription Payment</Heading>
            <Text m="0" fontSize=".8rem">Showing {1 + (page -1)*itemsPerPage} - {((page-1)*itemsPerPage) + page_size} of {total_count}</Text>
            </Flex>
       {  subscriptions && subscriptions.length > 0 ? <TableContainer mt="20px">
            <Table size='sm'>
              <Thead>
              <Tr >
                <Th sx={HeadStyle}>Name</Th>
                <Th sx={HeadStyle}>Membership-Type</Th>
                <Th sx={HeadStyle}>MembershipNo</Th>
                {/* <Th sx={HeadStyle}>Amount</Th> */}
                <Th sx={HeadStyle}>Outstanding</Th>
                {/* <Th sx={HeadStyle}>RoutId</Th> */}
                  <Th sx={HeadStyle}>Due-year</Th>
                  <Th sx={HeadStyle} w="50px"></Th>
                </Tr>
              </Thead>
              <Tbody>
              {subscriptions.map((eCandidate:any,index:number) =><ROWSTYLE key={index}>
                <Td sx={DataStyle}>{eCandidate.Name}</Td>
                  <Td sx={DataStyle}>{eCandidate.MembershipType}</Td>
                  <Td sx={DataStyle}>{eCandidate.MembershipNo}</Td>
                  {/* <Td sx={DataStyle}>{eCandidate.Level?.Amount}</Td> */}
                  <Td sx={DataStyle}>{eCandidate.OutstandingAmount}</Td>
                  {/* <Td sx={DataStyle}>{eCandidate.RouteId}</Td> */}
                   <Td sx={DataStyle}>{eCandidate.DueYear}</Td>
                  <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                      <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eCandidate}}/></div>
                  </Td>
                </ROWSTYLE>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          :'No Outstanding payment'  
        }
        <StylePaginateBox>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={page_count}
            previousLabel="<"
            renderOnZeroPageCount={null}
            forcePage={page-1}
          />
  
        </StylePaginateBox>
  
      </Box>
  }
  </>
    )
  }
  const StylePaginateBox = styled.div`
    width:100%;
    & > ul{
      list-style-type: none;
      text-align:center;
      padding:0;
      margin:0;
      margin-top:10px;
    } 
    & > ul > li{
      display: inline;
      margin:0 5px;
      padding:2px 5px;
      border-radius: 3px;
      background-color: transparent;
      color:var(--dark-green-color);
    }
    & > ul > li.selected{
      background-color: var(--highlight-paginate-background);
      color:var(--highlight-paginate-color);
    }
    & > ul > li:first-of-type,
    & > ul > li:last-of-type{
      font-weight: bold;
    }
  `
  
  const sx={
    ':hover':{
      bg:'var(--content-background)'
    }
  }
  
  const Option = (props:any)=>{
    const index = props.index;
    const candidate: CandidateType= props.candidate;
    const [ind,set_index] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom)
    const showUploadPaymentReceipt = () =>{
      set_modal({
        header:' Bulk Upload Subscription payment',
        content:<UploadPaymentReceipt candidate={candidate} />
      })
      set_open(true);
    }
    // console.log(candidate,'candidate')
    const onClick=()=>{
      if(index === ind){
        set_index(null);
        return;
      }
      set_index(index);
    }
    useEffect(()=>{
      return ()=>set_index(null)
    },[])
    return(
      <Popover>
      <PopoverTrigger>
        <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
      </PopoverTrigger>
      <PopoverContent width="fit-content">
        <PopoverArrow />
        <PopoverBody>
          <Grid templateColumns="1fr" p="6px">
            <GridItem sx={sx} p="8px 4px" onClick={showUploadPaymentReceipt}>Upload Receipt</GridItem>
            {/* <GridItem sx={sx} p="8px 4px">View Details</GridItem> */}
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
    )
  }


  const UploadPaymentReceipt = (props:{candidate:CandidateType}) => {
    const queryClient = useQueryClient();
    const [, set_open] = useAtom(openAtom);
    const [, set_Nopen] = useAtom(openNAtom);
    const [, set_notification] = useAtom(notificationAtom);
    const candidate: CandidateType = props?.candidate;
  
    const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
    const [errorMessage, setErrorMessage] = useState("");
  
    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles) => setUploadedFiles(acceptedFiles),
    });
  
    const removeFile = (name: string) => {
      setUploadedFiles((files) => files?.filter(file => file.name !== name));
    };
  
    const { mutate: addUpdate, isLoading } = useMutation({
      mutationKey: ["upload-payment-evidence"],
      mutationFn: async (data: FormData) => {
        return await apiCallFormData().post("/MembershipSetUp/student/UpdateManualStudentSubscriptionPayment", data);
      },
      onSuccess: (data) => {
        set_notification({
          type: "success",
          message: data?.data?.Message || "Payment Receipt Uploaded Successfully",
        });
        set_Nopen(true);
        queryClient.invalidateQueries({ queryKey: ["payment-evidence"] });
        setUploadedFiles([]);
      },
      onError: (error: any) => {
        let msg = "An error occurred. Please try again.";
        if (error?.response?.data) {
          const errorData = error.response.data;
          if (errorData.errors) {
            msg = Object.values(errorData.errors).flat().join(", ");
          } else {
            msg = errorData?.Message || errorData?.title || msg;
          }
        }
        set_notification({ type: "error", message: msg });
        set_Nopen(true);
      },
      onSettled: () => set_open(false),
    });

    const validationSchema = Yup.object().shape({
      UniqueId: Yup.string().required('Reference No is required'),
    });
    
  
    return (<Formik
  initialValues={{
    MembershipNo: candidate?.MembershipNo,
    Amount: candidate?.OutstandingAmount || 0,
    UniqueId: "",
    DueYear: candidate?.DueYear,
  }}
  validationSchema={validationSchema} // 👈 Add this line
  onSubmit={(values) => {
    if (!uploadedFiles.length) {
      set_notification({ type: "error", message: "Select a file" });
      set_Nopen(true);
      return;
    }

    const formData = new FormData();
    formData.append("MembershipNo", values.MembershipNo);
    formData.append("Amount", values.Amount.toString());
    formData.append("DueYear", values.DueYear);
    formData.append("UniqueId", values.UniqueId);
    formData.append("UploadReceipt", uploadedFiles[0]);

    addUpdate(formData);
  }}
>

      {(formik) => {
        const { values, errors, touched, setFieldValue } = formik;

        return (
          <Form>
            <Flex direction="column" align="center" gap="20px">
              <FormControl isInvalid={!!errors.MembershipNo && touched.MembershipNo}>
                <Box w="100%">
                Membership No <br />
                <Field
                  as={Input}
                  placeholder="Student / Member ID"
                  name="MembershipNo"
                  borderColor='green'
                  value={values.MembershipNo}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setFieldValue("MembershipNo", e.target.value)
                  }
                  disabled
                />
              </Box>
              </FormControl>

              <FormControl isInvalid={!!errors.Amount && touched.Amount}>
              <Box w="100%">
              Outstanding Amount <br />
                <Field
                  as={Input}
                  placeholder="Amount"
                  name="Amount"
                  borderColor='green'
                  value={values.Amount}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setFieldValue("Amount", e.target.value)
                  }
                  disabled
                />
                </Box>
              </FormControl>

              <FormControl isInvalid={!!errors.DueYear && touched.DueYear}>
              <Box w="100%">
              Due Year<br />
                <Field
                  as={Input}
                  placeholder="Due Year"
                  name="DueYear"
                  borderColor='green'
                  value={values.DueYear}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setFieldValue("DueYear", e.target.value)
                  }
                  disabled
                />
                </Box>
              </FormControl>

              <FormControl isInvalid={!!errors.UniqueId && touched.UniqueId}>
              <Box w="100%">
              Reference No <br />
                <Field
                  as={Input}
                  placeholder="Reference No"
                  name="UniqueId"
                  borderColor='black'
                  value={values.UniqueId}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setFieldValue("UniqueId", e.target.value)
                  }
                  required
                />
                </Box>
              </FormControl>

              {errorMessage && <Text color="red">{errorMessage}</Text>}

              <Flex flexDir="column" align="center" gap="20px">
                <Flex flexDir="column" gap="10px" w="100%">
                  <Box>Upload Payment Receipt:</Box>
                  <Box {...getRootProps()}>
                    <input {...getInputProps()} name="UploadReceipt" id="file" />
                    <Image
                      alt="upload document"
                      src={src}
                      w="100%"
                      h="150px"
                      objectFit="contain"
                      objectPosition="center"
                    />
                    <Text textAlign="center">
                      Drag 'n' drop receipt file here, or click to select
                    </Text>
                  </Box>

                  {uploadedFiles.length > 0 && (
                    <UnorderedList style={{ listStyleType: "none", padding: 0 }}>
                      {uploadedFiles.map((file) => (
                        <ListItem
                          key={file.name}
                          display="flex"
                          alignItems="center"
                          gap="10px"
                          fontSize="13px"
                          mt="5px"
                        >
                          {file.name}
                          <CancelIcon
                            style={{ marginLeft: "auto", cursor: "pointer" }}
                            onClick={() => removeFile(file.name)}
                          />
                        </ListItem>
                      ))}
                    </UnorderedList>
                  )}

                  <Button
                    type="submit"
                    bg="var(--dark-green-color)"
                    color="white"
                    isDisabled={isLoading}
                  >
                    {isLoading ? "Uploading..." : "Submit"}
                  </Button>
                </Flex>
              </Flex>
            </Flex>
          </Form>
        );
      }}
    </Formik>)
  }
  
    const Label = styled.label``; 
  
  
  
    const UploadSchema = Yup.object({});
  
    const UploadManualSubscription = () => {
    const [user] = useAtom(userAtom);
    const adminUserId = user?.Id || '';
    const queryClient = useQueryClient();
    const [, set_open] = useAtom(openAtom);
    const [, set_Nopen] = useAtom(openNAtom);
    const [, set_notification] = useAtom(notificationAtom);
  
    const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  
    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles) => {
        setUploadedFiles(acceptedFiles);
      },
    });
  
    const removeFile = (name: string) => {
      setUploadedFiles((files) => files.filter((file) => file.name !== name));
    };

    // const { data: currentUser } = useQuery({
    //   queryKey: ['current-admin-user'],
    //   queryFn: async () => {
    //     const res = await apiCall().get('/Administration/users/current');
    //     return res.data;
    //   },
    // });
    
  
    const { mutate: addUpdate, isLoading } = useMutation({
      mutationKey: ['subcription-payment'],
      mutationFn: async (data: FormData) => {
        const response = await apiCallFormData().post(
          `/MembershipSetUp/Student/UpdateManualBulkStudentSubscriptionPayment`,
          data,
          { responseType: 'blob' }
        );
        return response;
      },
      onSuccess: async (response) => {
        const contentType = response.headers['content-type'];
  
        if (contentType.includes('application/json')) {
          const data = await response.data.text();
          const parsedData = JSON.parse(data);
          set_notification({
            type: 'success',
            message: parsedData?.Message || 'Bulk payment uploaded successfully',
          });
        } else {
          const blob = new Blob([response.data], { type: contentType });
          let filename = 'DownloadedFile';
          const disposition = response.headers['content-disposition'];
          if (disposition) {
            const match = disposition.match(/filename="(.+?)"/);
            if (match) filename = match[1];
          }
  
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
  
          set_notification({
            type: 'success',
            message: 'Download Ready',
          });
        }
  
        set_Nopen(true);
        queryClient.invalidateQueries({ queryKey: ['all-subdcription-payment'] });
        setUploadedFiles([]);
      },
      onError: async (error: any) => {
        let errorMessage = 'Error Occurred';
        try {
          const text = await error.response.data.text();
          const parsedError = JSON.parse(text);
          errorMessage = parsedError?.Message || errorMessage;
        } catch {
          errorMessage = error?.message || errorMessage;
        }
  
        set_notification({
          type: 'error',
          message: errorMessage,
        });
  
        set_Nopen(true);
      },
      onSettled: () => {
        set_open(false);
      },
    });
      
    return (
      <Formik
      enableReinitialize
      initialValues={{
        Adminuser: user?.Id || '',
      }}
      validationSchema={UploadSchema}
      onSubmit={(values) => {
        if (uploadedFiles.length > 0) {
          const data = new FormData();
          data.append('Data', uploadedFiles[0]); // binary
          data.append('Adminuser', values.Adminuser);
          addUpdate(data);
        } else {
          set_notification({
            type: 'error',
            message: 'Select a file',
          });
          set_Nopen(true);
        }
      }}
    >

        {(formik) => {
          const { errors } = formik;
          return (
            <Form>
              <Flex flexDir="column" align="center" gap="20px">
                <Flex flexDir="column" gap="10px" w="100%">
                  <Box>Upload Bulk Students Subscription Payment:</Box>
                  <Box {...getRootProps()}>
                    <input {...getInputProps()} name="Data" id="file" />
                    <Image
                      alt="upload document"
                      src={src}
                      w="100%"
                      h="150px"
                      objectFit="contain"
                      objectPosition="center"
                    />
                    <UnorderedList sx={{ p: '0', m: '0', listStyleType: 'none' }}>
                      {uploadedFiles.slice(0, 1).map((file) => (
                        <ListItem
                          align="center"
                          gap="10px"
                          as={Flex}
                          sx={{ p: '5px 0' }}
                          fontSize="11px"
                          key={file.name}
                        >
                          <FileIcon />
                          {file.name}
                          <CancelIcon style={{ marginLeft: 'auto' }} onClick={() => removeFile(file.name)} />
                        </ListItem>
                      ))}
                    </UnorderedList>
                  </Box>
                </Flex>
  
                <Box>
                {errors?.Adminuser && typeof errors.Adminuser === 'string' && (
                  <Box color="red" fontSize="12px">
                    {errors.Adminuser}
                  </Box>
                )}

                </Box>
  
                <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading}>
                  {isLoading ? 'Loading...' : 'Submit'}
                </Button>
              </Flex>
            </Form>
          );
        }}
      </Formik>
    );
  };
  


    
  